/* eslint-disable import/no-anonymous-default-export */
// import React from 'react';
// import { createBrowserHistory } from 'history'
// import { Route, Switch, Router } from 'react-router'
// import PageNotFound from '../components/auth/PageNotFound'
// import { LoggedIn, Callback, SuSignin } from '../components/auth';
// import PrivateRoute from './PrvateRoute'
// import Layout from '../components/layout/Layout';

// export const history = createBrowserHistory({forceRefresh:true})

// const RouteLayout = (cProps) => (
//     <Router history={history}>
//         <Switch>
//             <Route path="/dashboard" props={cProps} component={Layout} />
//             <PrivateRoute exact path="/" props={cProps} component={Layout} />
//             <Route path="/susignin" component={ SuSignin } />
//             <Route path="/login" props={cProps} component={LoggedIn}></Route>
//             <Route path="/callback" props={cProps} component={Callback}></Route>
//             <Route component={PageNotFound} />
//             {/* <AuthProvider {...userManagerConfig}> */}
//                 {/* <Header/> */}

//                 {/* <PrivateRoute path="/callback" props={cProps} component={Callback}></PrivateRoute> */}

//             {/* </AuthProvider> */}

//         </Switch>
//     </Router>
// )

// export default RouteLayout
import { Beacon } from "../components/Icon";
import { createBrowserHistory } from 'history'
// import BeaconeMap from "../components/BeaconeMap";
import ManageBeacon from "../components/ManageBeacon";
import Location from "../components/Location";
import FullReport from "../components/FullReport";
import Zone from "../components/Zone";
// import { ManageApp } from "../components/Icon";

export const history = createBrowserHistory({ forceRefresh: true })

export default [
  // { path: "/", name: "Beacon", Component: BeaconeMap, breadcrumb: "beacon", Icon: <Beacon width="32" height="32" />, isSideBar:true },
  { path: "/full-report", name: "Fullreport", Component: FullReport, breadcrumb: "Locations", Icon: <Beacon width="32" height="32" />, isSideBar:true },
  { path: "/manage-beacons", name: "Locations", Component: ManageBeacon, breadcrumb: "Locations", Icon: <Beacon width="32" height="32" />, isSideBar:true },
  { path: "/location", name: "Location Detail", Component: Location, breadcrumb: "Location Detail", Icon: <Beacon width="32" height="32" />, isSideBar:false },
  { path: "/zone", name: "Zone Detail", Component: Zone, breadcrumb: "Location Detail", Icon: <Beacon width="32" height="32" />, isSideBar:false }
];